import { PLAN_TYPE_FR } from './plan';
import { TRANSLATION_COLLABORATORS } from '../translations/collaborators';

export const COLLABORATOR_DETAIL_TABS = [
  {
    title: TRANSLATION_COLLABORATORS.detail.hero.tabs.protection,
    type: 'health'
  },
  {
    title: TRANSLATION_COLLABORATORS.detail.hero.tabs.benefits,
    type: 'benefits'
  },
  {
    title: TRANSLATION_COLLABORATORS.detail.hero.tabs.balance,
    type: 'balance'
  },
  {
    title: TRANSLATION_COLLABORATORS.detail.hero.tabs.rent,
    type: PLAN_TYPE_FR
  },
  {
    title: TRANSLATION_COLLABORATORS.detail.hero.tabs.contract,
    type: 'contract'
  },
  {
    title: TRANSLATION_COLLABORATORS.detail.hero.tabs.contact,
    type: 'contact'
  }
];

export const COLLABORATOR_DETAILS_DEPENDENT_RELATIONSHIP = ['partner', 'child'];
